// Builds a consistent error envelope to feed back to the LLM via addToolOutput
// so it can craft a friendly, actionable message for the user. Keeps `error`
// as a string for the chat card UI; the LLM also sees structured fields.

export interface ToolErrorEnvelope {
    success: false;
    error: string;
    validationErrors?: unknown;
    errorCode?: string;
    httpStatus?: number;
}

export function buildToolError(result: any, fallback: string): ToolErrorEnvelope {
    if (!result || typeof result !== "object") {
        return { success: false, error: fallback };
    }
    const message = (result.message as string) || (result.error as string) || fallback;
    const validationErrors = result.fields ?? result.validationErrors;
    const errorCode = result.code as string | undefined;
    const httpStatus = result.status as number | undefined;
    const envelope: ToolErrorEnvelope = { success: false, error: message };
    if (validationErrors && typeof validationErrors === "object" && Object.keys(validationErrors).length > 0) {
        envelope.validationErrors = validationErrors;
    }
    if (errorCode) envelope.errorCode = errorCode;
    if (httpStatus) envelope.httpStatus = httpStatus;
    return envelope;
}
